module.exports = __webpack_public_path__ + "static/media/piece-collection-btn.4fe434bf.png";